import type {
    getOobeFunnelEvent,
    getSendLogs,
    getSendSpecifiedLogs,
    getSendSpecifiedLogsWithConfig,
    getStartSpecifiedReproDataCollectors,
    getStopSpecifiedReproDataCollectors,
    getGetRegisteredReproDataCollectors,
    getGetRuntimeModeStatus,
} from '../lazyIndex';
import { LazyAction } from 'owa-bundling-light';
import { lazyModule } from '../lazyFunctions';

export const lazyGetOobeFunnelEvent: LazyAction<typeof getOobeFunnelEvent, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.getOobeFunnelEvent);

export const lazyGetSendLogs: LazyAction<typeof getSendLogs, typeof lazyModule> = new LazyAction(
    lazyModule,
    m => m.getSendLogs
);

export const lazyGetSendSpecifiedLogs: LazyAction<typeof getSendSpecifiedLogs, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.getSendSpecifiedLogs);

export const lazyGetSendSpecifiedLogsWithConfig: LazyAction<
    typeof getSendSpecifiedLogsWithConfig,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getSendSpecifiedLogsWithConfig);

export const lazyGetStartSpecifiedReproDataCollectors: LazyAction<
    typeof getStartSpecifiedReproDataCollectors,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getStartSpecifiedReproDataCollectors);

export const lazyGetStopSpecifiedReproDataCollectors: LazyAction<
    typeof getStopSpecifiedReproDataCollectors,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getStopSpecifiedReproDataCollectors);

export const lazyGetGetRegisteredReproDataCollectors: LazyAction<
    typeof getGetRegisteredReproDataCollectors,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getGetRegisteredReproDataCollectors);

export const lazyGetGetRuntimeModeStatus: LazyAction<
    typeof getGetRuntimeModeStatus,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getGetRuntimeModeStatus);
